<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="row">
      <div
        class="col-md-12 mb-4 d-inline"
        align="right"
        v-if="currentLiveStream && currentLiveStream.status !== 'live'"
      >
        <base-button
          type="primary"
          class="pl-4 pr-4"
          @click="onPrepareLiveClicked()"
          :disabled="isLoading || currentLiveStream.status === 'preparing'"
          v-if="
            !isAdmin &&
              currentLiveStream &&
              (currentLiveStream.status === 'pending' ||
                currentLiveStream.status === 'preparing')
          "
          >{{
            currentLiveStream.status === "preparing"
              ? "Preparing"
              : "Prepare Live"
          }}</base-button
        >
        <base-button
          type="primary"
          class="pl-4 pr-4"
          @click="onPublishLiveClicked()"
          v-if="
            !isAdmin &&
              currentLiveStream &&
              currentLiveStream.status === 'started'
          "
          >Publish Live</base-button
        >
        <base-button
          v-if="!isAdmin && currentLiveStream.status !== 'ended'"
          type="danger"
          class="pl-4 pr-4"
          @click="onDeleteClicked()"
          >Delete</base-button
        >
      </div>
      <div
        class="col-md-12 mb-4"
        align="right"
        v-if="
          !isAdmin && currentLiveStream && currentLiveStream.status === 'live'
        "
      >
        <base-button type="danger" class="pl-4 pr-4" @click="onEndLiveClicked()"
          >End Live Now</base-button
        >
      </div>

      <div class="col-md-7 col-sm-12" v-if="currentLiveStream">
        <div class="card pl-4 pr-4 pt-4 pb-4">
          <div class="relative-pos">
            <!-- <img src="@/assets/live_stream_picture_1.png" class="img-fluid" alt /> -->
            <video-player :options="playerOptions" />
            <div class="top-left mt-3 text-center">
              <img
                class="icon-live-stream"
                src="@/assets/icons/icon_live_stream.png"
                width="16"
                height="16"
                alt
              />
              <span class="text-white text-sm ml-1">{{ liveSpent }}</span>
            </div>
            <div class="top-right mt-3 text-center">
              <span class="text-white text-sm mr-1">{{ viewerCount }}</span>
              <img
                src="@/assets/icons/icon_view_count.png"
                width="24"
                height="16"
                alt
              />
            </div>
          </div>
          <h4 class="pt-3">{{ currentLiveStream.title }}</h4>
          <p class="description">{{ currentLiveStream.description }}</p>
          <h5 v-if="currentLiveStream.status === 'live'" class="pb-3">
            Live Link:
            <a :href="encryptedLiveUrl" target="_blank">{{
              encryptedLiveUrl
            }}</a>
          </h5>
          <!-- Profile Picture -->
          <div class="media align-items-center">
            <span class="avatar avatar-lg rounded-circle pointer-cursor">
              <img
                alt="Image placeholder"
                :src="
                  currentLiveStream.streamer.streamerProfile
                    ? currentLiveStream.streamer.streamerProfile
                    : require('@/assets/default_profile_picture.png')
                "
              />
            </span>
            <div class="media-body ml-2 d-lg-block">
              <span
                class="mb-0 text-sm font-weight-bold text-black pointer-cursor"
                v-if="currentLiveStream.streamer"
                >{{ currentLiveStream.streamer.name }}</span
              >
            </div>
          </div>
          <!--  -->
          <hr />
          <label
            for="Fake Viewer"
            v-if="canAddFakeViewers && currentLiveStream.status === 'live'"
            >Fake Viewer</label
          >
          <div
            class="row"
            v-if="canAddFakeViewers && currentLiveStream.status === 'live'"
          >
            <div class="col-md-6">
              <base-input
                alternative
                placeholder="Enter viewer"
                v-model="fakeViewers"
              />
            </div>
            <div class="col-md-6">
              <base-button
                type="primary"
                class="btn-radius mb-2"
                :disabled="isLoading"
                @click="onApplyFakeViewers()"
                >Apply</base-button
              >
              <base-button
                type="primary"
                class="btn-radius mb-2"
                @click="onRefreshView()"
                :disabled="refreshingView"
                >Refresh View</base-button
              >
            </div>

            <div class="col-md-12" v-if="fakeViewerCount > 0">
              <h4>Added Fake Viewers: {{ fakeViewerCount }}</h4>
            </div>
            <div class="col-md-12 " v-if="showRefreshSuccessMessage">
              <h4 class="text-success">Refresh view successfully</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5 col-sm-12 mt-sm-4 mt-md-0" v-if="currentLiveStream">
        <div
          class="card pl-4 pr-4 pb-4 pt-4"
          v-if="
            (comments && comments.length > 0) ||
              pinComment ||
              (currentLiveStream.status === 'live' && !isAdmin)
          "
        >
          <!-- Pinned Comment -->
          <div class="col-md-12 pt-2 pb-2 pinned-comment" v-if="pinComment">
            <div class="row">
              <div class="col-md-10 col-8 pl-0">
                <!-- Profile Picture -->
                <div class="media align-items-center ml-2">
                  <span class="avatar avatar-sm rounded-circle pointer-cursor">
                    <img
                      alt="Image placeholder"
                      :src="
                        pinComment.streamer.streamerProfile
                          ? pinComment.streamer.streamerProfile
                          : require('@/assets/default_profile_picture.png')
                      "
                    />
                  </span>
                  <div class="media-body ml-2 d-lg-block">
                    <span
                      class="
                        mb-0
                        text-sm
                        font-weight-bold
                        text-black
                        pointer-cursor
                      "
                      >{{ pinComment.streamer.name }}</span
                    >
                  </div>
                </div>
                <!-- -->
              </div>
              <div class="col-md-2 col-4 mt-1" align="right">
                <img src="@/assets/icons/icon_pinned_comment.png" alt />
              </div>
            </div>

            <p class="mt-2 text-sm">{{ pinComment.comment }}</p>
          </div>
          <!--  -->
          <!-- Comments -->
          <div
            class="col-md-12 mt-4 pl-0 pr-0 comment-section"
            id="comment-container"
            v-if="comments && comments.length > 0"
            @scroll="onScroll"
          >
            <div v-for="(comment, i) in comments" :key="i + comment.comment">
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle pointer-cursor">
                  <img
                    alt="Image placeholder"
                    :src="
                      comment.user.profile
                        ? comment.user.profile
                        : require('@/assets/default_profile_picture.png')
                    "
                  />
                </span>
                <div class="media-body ml-2 d-lg-block">
                  <span
                    class="
                      mb-0
                      text-sm
                      font-weight-bold
                      text-black
                      pointer-cursor
                    "
                    >{{
                      `${comment.user.firstName} ${comment.user.lastName}`
                    }}</span
                  >
                  <span
                    style="float: right; cursor: pointer"
                    @click="onBanClicked(comment)"
                  >
                    <img
                      src="@/assets/icons/ic_menu.svg"
                      width="24"
                      height="24"
                    />
                  </span>
                </div>
              </div>
              <p class="ml-1 mt-2 text-sm">{{ comment.comment }}</p>
            </div>
          </div>
          <!--  -->
          <div
            class="col-md-12 mt-4"
            v-if="!isAdmin && currentLiveStream.status === 'live'"
          >
            <!-- <textarea
              class="form-control"
              rows="3"
              placeholder="write something here..."
              v-model="comment"
            ></textarea>-->
            <div>
              <div class="relative">
                <textarea
                  class="form-control"
                  rows="3"
                  placeholder="write something here..."
                  v-model="comment"
                ></textarea>

                <emoji-picker @emoji="appendComment" :search="search">
                  <div
                    class="emoji-invoker"
                    slot="emoji-invoker"
                    slot-scope="{ events: { click: clickEvent } }"
                    @click.stop="clickEvent"
                  >
                    <svg
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                      />
                    </svg>
                  </div>
                  <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                    <div
                      class="emoji-picker col-md-12"
                      style="right: 0; top: 50px"
                    >
                      <div class="emoji-picker__search">
                        <input type="text" v-model="search" v-focus />
                      </div>
                      <div>
                        <div
                          v-for="(emojiGroup, category) in emojis"
                          :key="category"
                        >
                          <h5>{{ category }}</h5>
                          <div class="emojis">
                            <span
                              v-for="(emoji, emojiName) in emojiGroup"
                              :key="emojiName"
                              @click="insert(emoji)"
                              :title="emojiName"
                              >{{ emoji }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </emoji-picker>
              </div>
            </div>
            <div class="text-center mt-4">
              <base-button
                type="primary"
                class="btn-radius btn-reply"
                @click="onPinCommentClicked()"
                :disabled="isPinningComment"
                >Pin Comment</base-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Poll Question Section -->
    <div class="row" v-if="pollQuestion">
      <div class="col-md-12">
        <div class="card-header mt-4">
          <h4 class="text-light mb-4">Question</h4>
          <h2>{{ pollQuestion.question }}</h2>
          <h4 class="text-light mt-4 mb-4">Answers</h4>
          <span
            v-for="(answer, index) in pollQuestion.answers"
            :key="answer.id"
          >
            {{ answer.answer }}
            <base-progress
              class="mt-3"
              type="primary"
              :value="calPoll(index)"
              :height="7"
              :showPercentage="false"
            ></base-progress>
          </span>
          <div class="col-md-12 pl-0 mt-5">
            <base-button type="primary" @click="onExportPollClicked()"
              >Export Poll</base-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- Poll Question Section -->
    <div
      class="row"
      v-if="
        !isAdmin && currentLiveStream && currentLiveStream.status !== 'ended'
      "
    >
      <div class="col-md-7">
        <div class="card-header mt-4">
          <h1>Update Live Stream</h1>
          <hr />
          <form action="#">
            <div class="row">
              <div class="col-md-12">
                <label>Your Live Stream URL:</label>
                <p class="streaming-url">{{ getStreamingUrl() }}</p>
              </div>
              <div class="col-md-12 mt-2 mb-4">
                <label>Your Streaming Key:</label>
                <p class="streaming-url">{{ currentLiveStream.streamKey }}</p>
              </div>
              <div class="col-md-12">
                <label for="Title">Title</label>
                <base-input
                  alternative
                  placeholder="Title"
                  v-model="title"
                  v-if="title"
                />
              </div>
              <div class="col-md-12">
                <label for="Description">Description</label>
                <textarea
                  class="form-control"
                  rows="3"
                  placeholder="Description"
                  v-model="description"
                ></textarea>
              </div>
              <div class="col-md-12 text-center mb-4 mt-6">
                <base-button
                  type="primary"
                  class="btn-radius"
                  @click="onUpdateClicked()"
                  :disabled="isLoading"
                  >Update</base-button
                >
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-5">
        <div class="card-header mt-4">
          <div class="col-md-12 inline-flex">
            <h1>Poll Question</h1>
          </div>
          <hr />
          <div class="col-md-12 mt-3">
            <div>
              <label for="Question">Question</label>
              <span class="error" v-if="!question">* field required</span>
              <base-input
                alternative
                v-model="question"
                placeholder="Question"
              />
            </div>
            <div v-for="(answer, index) in answers" :key="answer.id">
              <label for="Answer">{{ `Answer` + (index + 1) }}</label>
              <button
                v-if="!answer.id"
                type="button"
                class="close"
                @click="removeAnswer(index)"
              >
                <span>×</span>
              </button>
              <base-input
                alternative
                v-model="answers[index].answer"
                placeholder="Answer"
                :disabled="answer.id"
              />
            </div>
            <base-button
              outline
              type="primary"
              @click="addAnswer"
              :disalbed="isLoading"
              >Add Answer</base-button
            >
            <base-button
              type="primary"
              @click="onCreatePollClicked()"
              :disabled="isLoading"
              >{{ pollQuestion ? "Update" : "Create" }}</base-button
            >
            <div class="mt-4" v-if="!validAnswer()">
              <span class="answer-validation"
                >* Answer must be more than 2</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Confirm live stream button action -->
    <confirmation-modal
      v-if="currentLiveStream"
      :isLoading="isLoading"
      :showModal.sync="showModal"
      :message="
        isDeleteClicked
          ? 'Are you sure want to delete?'
          : currentLiveStream.status === 'started'
          ? 'Are you sure want to publish live now?'
          : 'Are you sure want to end live now?'
      "
      :positiveText="
        isDeleteClicked
          ? 'Delete'
          : currentLiveStream.status === 'started'
          ? 'Publish Now'
          : 'End Now'
      "
      negativeText="Cancel"
      @onPositiveClicked="onPositiveClicked()"
      @onNegativeClicked="onNegativeClicked()"
    />
    <!--  -->
    <!-- Confirm Ban User -->
    <confirmation-modal
      :isLoading="isLoading"
      :showModal.sync="showBanConfirm"
      type="danger"
      message="Are you sure you want to ban this user?"
      positiveText="Confirm"
      negativeText="Cancel"
      @onPositiveClicked="onConfirmBanned()"
      @onNegativeClicked="onCancelBanned()"
    />
    <!--  -->
  </div>
</template>

<script>
import EmojiPicker from "vue-emoji-picker";

import { BASE_WEBSOCKET_URL, WEB_STREAMING_URL } from "@/common/config";

import JwtService from "@/common/jwt.service";

import { formatNumber, getElapsedTime } from "@/common/utils";

import "video.js/dist/video-js.css";
import VideoPlayer from "@/views/LiveStream/VideoPlayer";
import "videojs-flash";

import store from "@/store";

import { mapState, mapGetters } from "vuex";
import {
  ADD_FAKE_VIEWERS,
  GET_LIVE_STREAM,
  GET_COMMENTS,
  UPDATE_LIVE_STREAM,
  PIN_COMMENT,
  CREATE_POLL_QUESTION,
  UPDATE_POLL_QUESTION,
  UPDATE_LIVE_STREAM_STATUS,
  EXPORT_POLL,
  RESET_COMMENT_STATE,
  GET_WOWZA_STATUS,
  DELETE_LIVE_STREAM,
  INVALIDATE_STREAM,
  UPDATE_USER_STATUS
} from "@/store/actions.type";

import io from "socket.io-client";
import aesjs from "aes-js";
import base64url from "base64url";

var socket = null;

export default {
  components: {
    VideoPlayer,
    EmojiPicker
  },
  data() {
    return {
      title: "",
      description: "",
      fakeViewers: "",
      viewerCount: 0,
      comment: "",
      pinComment: "",
      question: "",
      answers: [],
      realTimePollResult: null,
      liveSpent: "00:00:00",
      playerOptions: {
        height: "300",
        sources: [
          {
            src: ""
          }
        ],
        autoplay: true,
        controls: true
      },
      page: 1,
      isLoadingComment: false,
      isAllCommentLoaded: false,
      isOnBottom: true,
      showModal: false,
      search: "",
      liveSpentCountDown: null,
      checkStatusCountDown: null,
      hasLeftRoom: false,
      fakeViewerCount: 0,
      isDeleteClicked: false,
      showBanConfirm: false,
      selectedUserComment: null,
      refreshingView: false,
      showRefreshSuccessMessage: false,
      showRefreshMessageTimeout: null
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch(GET_LIVE_STREAM, to.params.id).then(() => next());
  },
  created() {
    this.title = this.currentLiveStream.title;
    this.description = this.currentLiveStream.description;
    this.playerOptions.sources[0].src = this.currentLiveStream.streamSource;

    if (this.currentLiveStream.streamProvider === "ant_media") {
      this.checkStreamingStatus();
    } else {
      if (this.currentLiveStream.streamId !== "") {
        this.checkStreamingStatus();
      } else {
        if (this.currentLiveStream.status !== "live") {
          this.currentLiveStream.status = "started";
        }
      }
    }

    this.$store
      .dispatch(GET_COMMENTS, {
        id: this.currentLiveStream.id,
        page: this.page
      })
      .then(() => {
        this.page++;
        this.scrollToBottom();
      });
    this.pinComment = this.pinnedComment;
    if (this.displayViewCount < 0) {
      this.viewerCount = formatNumber(parseInt(this.displayViewCount) * -1);
    } else {
      this.viewerCount = formatNumber(parseInt(this.displayViewCount));
    }
    this.fakeViewerCount = this.currentLiveStream.fakeViews;
    if (this.pollQuestion) {
      this.question = this.pollQuestion.question;
      this.answers = this.pollQuestion.answers;
    } else {
      this.answers = [
        {
          answer: ""
        },
        {
          answer: ""
        }
      ];
    }
    this.realTimePollResult = this.pollResult;

    if (this.currentLiveStream.status === "live") {
      this.initSocketEvent();
    } else if (this.currentLiveStream.status === "ended") {
      this.liveSpent = getElapsedTime(
        new Date(this.currentLiveStream.liveEndedAt).getTime(),
        new Date(this.currentLiveStream.liveStartedAt).getTime()
      );
    }
  },
  beforeDestroy() {
    if (
      this.currentLiveStream &&
      !this.hasLeftRoom &&
      this.currentLiveStream.status === "live"
    ) {
      socket.emit("leaveRoom", { room: this.currentLiveStream.room });
      this.hasLeftRoom = true;
    }
    if (this.liveSpentCountDown) {
      clearInterval(this.liveSpentCountDown);
    }
    if (this.checkStatusCountDown) {
      clearTimeout(this.checkStatusCountDown);
    }

    if (this.showRefreshMessageTimeout) {
      clearTimeout(this.showRefreshMessageTimeout);
    }

    if (socket) {
      socket.close();
    }
    this.$store.dispatch(RESET_COMMENT_STATE);
  },
  methods: {
    initSocketEvent() {
      socket = io(`${BASE_WEBSOCKET_URL}/socket/streamings`, {
        query: {
          token: JSON.parse(JwtService.getUser()).token
        }
      });

      socket.on("connect", () => {
        // console.log('connect ')
      });
      socket.on("disconnect", () => {
        // console.log('disconnect')
      });
      socket.on("error", () => {
        // console.log('error')
      });
      this.viewerCount = formatNumber(parseInt(this.displayViewCount + 1));
      this.liveSpentCountDown = setInterval(() => {
        this.liveSpent = getElapsedTime(
          new Date().getTime(),
          new Date(this.currentLiveStream.liveStartedAt).getTime()
        );
      }, 1000);

      socket.on("join", displayView => {
        this.viewerCount = formatNumber(parseInt(displayView.displayViews));
      });

      socket.on("comments", comment => {
        if (comment.user) {
          this.comments.push({
            id: comment.commentId,
            comment: comment.comment,
            user: {
              id: comment.user.id,
              profile: comment.user.profile,
              firstName: comment.user.firstName,
              lastName: comment.user.lastName
            }
          });

          setTimeout(() => {
            if (this.isOnBottom) {
              this.scrollToBottom();
            }
          }, 100);
        }
        if (comment.streamer) {
          this.pinComment = comment.comment;
        }
      });

      socket.on("pollResult", result => {
        this.realTimePollResult = result;
      });

      window.addEventListener(
        "beforeunload",
        event => {
          if (!this.hasLeftRoom && this.currentLiveStream.status === "live") {
            socket.emit("leaveRoom", { room: this.currentLiveStream.room });
            this.hasLeftRoom = true;
          }
        },
        false
      );
      socket.emit("joinRoom", { room: this.currentLiveStream.room });
    },
    setTitle(title) {
      this.title = title;
    },
    setDescription(description) {
      this.description = description;
    },
    addAnswer() {
      this.answers.push({ answer: "" });
    },
    removeAnswer(index) {
      this.answers.pop(index);
    },
    onUpdateClicked() {
      if (this.title) {
        this.$store.dispatch(UPDATE_LIVE_STREAM, {
          id: this.currentLiveStream.id,
          title: this.title,
          description: this.description
        });
      }
    },
    onPinCommentClicked() {
      if (this.comment) {
        this.$store
          .dispatch(PIN_COMMENT, {
            id: this.currentLiveStream.id,
            comment: this.comment
          })
          .then(() => (this.comment = ""));
      }
    },
    onApplyFakeViewers() {
      if (this.fakeViewers && !isNaN(this.fakeViewers)) {
        this.$store
          .dispatch(ADD_FAKE_VIEWERS, {
            id: this.currentLiveStream.id,
            count: parseInt(this.fakeViewers)
          })
          .then(() => {
            this.fakeViewerCount =
              parseInt(this.fakeViewerCount) + parseInt(this.fakeViewers);
            this.fakeViewers = "";
          });
      }
    },
    async onRefreshView() {
      try {
        if (this.showRefreshMessageTimeout) {
          clearTimeout(this.showRefreshMessageTimeout);
        }

        this.showRefreshSuccessMessage = false;
        this.refreshingView = true;
        await this.$store.dispatch(
          INVALIDATE_STREAM,
          this.currentLiveStream.id
        );
        this.refreshingView = false;
        this.showRefreshSuccessMessage = true;

        this.showRefreshMessageTimeout = setTimeout(() => {
          this.showRefreshSuccessMessage = false;
          this.showRefreshMessageTimeout = null;
        }, 3000);
      } catch {
        this.refreshingView = false;
      }
    },
    onCreatePollClicked() {
      if (this.question) {
        if (this.validAnswer()) {
          if (this.pollQuestion) {
            const answerIds = [];
            const answers = [];
            const deletedAnswerIds = [];
            this.pollQuestion.answers.map(a => {
              if (a.id) {
                answerIds.push(a.id);
              } else {
                answerIds.push(0);
              }
              answers.push(a.answer);
              deletedAnswerIds.push(0);
            });
            this.$store
              .dispatch(UPDATE_POLL_QUESTION, {
                id: this.pollQuestion.id,
                answerIds: answerIds,
                deletedAnswerIds: deletedAnswerIds,
                answers: answers,
                question: this.pollQuestion.question
              })
              .then(data => {
                this.question = data.question;
                this.answers = data.answers;
              });
          } else {
            this.createPollQuestion();
          }
        }
      }
    },
    createPollQuestion() {
      const answers = [];
      this.answers.map(a => answers.push(a.answer));
      this.$store
        .dispatch(CREATE_POLL_QUESTION, {
          streamingId: this.currentLiveStream.id,
          question: this.question,
          answers: answers
        })
        .then(() => {
          this.question = this.pollQuestion.question;
          this.answers = this.pollQuestion.answers;
          this.realTimePollResult = 0;
        });
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.isOnBottom = true;
      } else {
        this.isOnBottom = false;
      }
      if (
        scrollTop <= 50 &&
        !this.isLoadingComment &&
        !this.isAllCommentLoaded
      ) {
        this.isLoadingComment = true;
        this.$store
          .dispatch(GET_COMMENTS, {
            id: this.currentLiveStream.id,
            page: this.page
          })
          .then(({ data }) => {
            this.isLoadingComment = false;
            if (data.length <= 0) {
              this.isAllCommentLoaded = true;
              return;
            }
            this.page++;
          });
      }
    },
    onEndLiveClicked() {
      this.showModal = true;
      this.isDeleteClicked = false;
    },
    onPublishLiveClicked() {
      this.showModal = true;
      this.isDeleteClicked = false;
    },
    onPrepareLiveClicked() {
      this.$store
        .dispatch(UPDATE_LIVE_STREAM_STATUS, {
          id: this.currentLiveStream.id,
          status: "preparing"
        })
        .then(() => {
          if (this.currentLiveStream.streamProvider === "ant_media") {
            this.checkStreamingStatus();
          } else {
            if (this.currentLiveStream.streamId !== "") {
              this.checkStreamingStatus();
            } else {
              this.currentLiveStream.status = "started";
            }
          }
        });
    },
    onPositiveClicked() {
      if (this.isDeleteClicked) {
        this.$store
          .dispatch(DELETE_LIVE_STREAM, this.currentLiveStream.id)
          .then(res => {
            this.showModal = false;
            setTimeout(() => {
              this.$router.push({ path: "/live_stream" });
            }, 0);
          });
      } else if (this.currentLiveStream.status === "started") {
        this.publishLive();
      } else if (this.currentLiveStream.status === "live") {
        this.$store
          .dispatch(UPDATE_LIVE_STREAM_STATUS, {
            id: this.currentLiveStream.id,
            status: "ended"
          })
          .then(() => {
            this.showModal = false;
            setTimeout(() => {
              this.$router.push({ path: "/live_stream" });
            }, 0);
          });
      }
    },
    checkStreamingStatus() {
      if (this.currentLiveStream.status === "preparing") {
        this.$store
          .dispatch(GET_WOWZA_STATUS, this.currentLiveStream.id)
          .then(data => {
            if (data === "starting") {
              this.checkStatusCountDown = setTimeout(() => {
                this.checkStreamingStatus();
              }, 10000);
            } else if (data === "started") {
              this.currentLiveStream.status = "started";
            }
          });
      }
    },
    async publishLive() {
      try {
        await this.$store.dispatch(UPDATE_LIVE_STREAM_STATUS, {
          id: this.currentLiveStream.id,
          status: "live"
        });
        this.showModal = false;
        this.initSocketEvent();
      } catch {}

      await this.$store.dispatch(INVALIDATE_STREAM, this.currentLiveStream.id);
    },
    onNegativeClicked() {
      this.showModal = false;
    },
    calPoll(index) {
      if (this.realTimePollResult) {
        const result = this.realTimePollResult.answers[index];
        if (result) {
          const resultPercentage =
            (result.polls * 100) / this.realTimePollResult.totalPolls;
          return resultPercentage > 0 ? resultPercentage : 0;
        }
      }
      return 0;
    },
    scrollToBottom() {
      const container = document.getElementsByClassName("comment-section")[0];
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },
    validAnswer() {
      return this.answers.filter(answer => answer).length >= 2;
    },
    getStreamingUrl() {
      return this.currentLiveStream.streamURL;
    },
    onExportPollClicked() {
      this.$store
        .dispatch(EXPORT_POLL, this.currentLiveStream.poll.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Poll.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },
    appendComment(emoji) {
      this.comment += emoji;
    },
    onDeleteClicked() {
      this.showModal = true;
      this.isDeleteClicked = true;
    },
    onBanClicked(comment) {
      this.selectedUserComment = comment;
      this.showBanConfirm = true;
    },
    onConfirmBanned() {
      this.$store
        .dispatch(UPDATE_USER_STATUS, {
          id: this.selectedUserComment.user.id,
          status: "disabled"
        })
        .then(() => {
          const index = this.$store.state.comment.comments.indexOf(
            this.selectedUserComment
          );
          this.$store.state.comment.comments.pop(index);
          this.showBanConfirm = false;
          this.selectedUserComment = null;
        })
        .catch(() => {
          this.showBanConfirm = false;
          this.selectedUserComment = null;
        });
    },
    onCancelBanned() {
      this.showBanConfirm = false;
    }
  },
  computed: {
    ...mapState({
      isPinningComment: state => state.comment.isPinnigComment,
      pollQuestion: state => state.liveStream.pollQuestion,
      pollResult: state => state.liveStream.pollResult,
      isLoading: state => state.liveStream.isLoading
    }),
    ...mapGetters([
      "currentLiveStream",
      "displayViewCount",
      "comments",
      "pinnedComment",
      "isAdmin",
      "canAddFakeViewers"
    ]),
    encryptedLiveUrl() {
      /**
    https://gist.github.com/franzwarning/1e5fab9d7d2e90086e567768e71904be
     */
      var key = aesjs.utils.utf8.toBytes("cRfUjXn2r5u7x!A%D*G-KaPdSgVkYp3s");
      var iv = aesjs.utils.utf8.toBytes("NdRfUjXn2r5u8x/A");

      var aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
      var textBytes = aesjs.utils.utf8.toBytes(this.$route.params.id);
      var padded = aesjs.padding.pkcs7.pad(textBytes);
      var encryptedBytes = aesCbc.encrypt(padded);

      return `${WEB_STREAMING_URL}?stream=${base64url.encode(encryptedBytes)}`;
    }
  }
};
</script>

<style scoped>
.description {
  font-size: 14px !important;
  color: black;
}
.relative-pos {
  position: relative;
}
.top-left {
  position: absolute;
  top: 8px;
  left: 16px;
  background-color: #ec0000;
  padding: 0.4rem 1rem;
  border-radius: 8px;
}
.top-right {
  position: absolute;
  top: 8px;
  right: 16px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0.4rem 1rem;
  border-radius: 8px;
}
.icon-live-stream {
  margin-bottom: 7px;
}
hr {
  margin-top: 1rem !important;
  border-top: 1px solid rgba(220, 220, 220, 0.2);
}
.btn-radius {
  border-radius: 20px !important;
}
.card-header {
  border-radius: 5px !important;
  box-shadow: 0 4px 8px 0 rgba(255, 255, 255, 0.2),
    0 6px 20px 0 rgba(92, 92, 92, 0.19);
}
.pinned-comment {
  background-color: #f7f7f7;
  border-radius: 10px;
}
.btn-reply {
  padding: 0.7rem 2rem !important;
}
.inline-flex {
  display: inline-flex;
}
.comment-section {
  max-height: 750px;
  overflow-y: auto;
}
.answer-validation {
  color: #fb6340 !important;
  font-size: 14px;
}
.streaming-url {
  /* color: #962100; */
  font-weight: 600;
}

.relative {
  position: relative !important;
}

.inline-block {
  display: inline-block !important;
}

.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
  outline: none;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}
.float-right {
  float: right;
}
</style>
